import styled, { css } from 'styled-components';
import { Form } from 'react-bootstrap';

import mixin from '../../../_foundations/Mixin';
import JobCategoryPicker from '../JobCategoryPicker';
import QuickSearch from '../QuickSearch';

export const JobListContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  row-gap: 0;
  height: 100%;
`;

export const JobListFilters = styled.div`
  padding: 0.75rem;
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 0.75rem;
`;

export const JobListEmpty = styled.div`
  padding: 2rem 0.75rem;
  text-align: center;
  & p {
    ${mixin.text({ size: 200 })}
    margin: 0.75rem 0;
    color: var(--neutral-600);
  }
`;

export const JobListFilter = styled(Form.Group)`
  & {
    margin: 0;
    padding: 0;
  }
  & .tag-picker__control {
    min-height: 42px;
  }
  & .tag-picker__placeholder {
    font-size: 0.9rem;
  }
  & .form-group {
    margin: 0;
  }
`;
export const IconWrap = styled.i`
  display: inline-grid !important;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 1em;
  height: 1em;
  vertical-align: middle;
  & > svg {
    fill: currentColor;
    stroke: currentColor;
    shape-rendering: geometricPrecision;
    height: 1em;
  }
  & > svg path {
    shape-rendering: geometricPrecision;
  }
  ${({ size }) =>
    size &&
    css`
      width: ${size}px;
      height: ${size}px;
      & > svg {
        height: ${size}px;
      }
    `}
  ${({ color }) =>
    color &&
    css`
      color: var(--${color});
    `}
`;

export const JobListKeyword = styled(QuickSearch)`
  position: relative;
`;

export const JobListCategoryPicker = styled(JobCategoryPicker)``;

export const JobListResults = styled.div`
  overflow: auto;
  ${mixin.border()}
  border-width: 1px 0 0;
  .pagination {
    margin: 0.75rem 0;
  }
  .pagination .page-item .page-link {
    padding: 0.25rem;
    min-width: 2rem;
    text-align: center;
  }
  ${(props) =>
    props.primaryColor &&
    css`
      .pagination .page-item.active .page-link {
        background: ${props.primaryColor};
      }
    `}
`;
